import { Context, createContext, useContext, useState } from 'react';
import { VideoCardData } from '../types/video-card.types';

export interface AppStateContextType {
    isSidePanelOpen: boolean,
    cycleSidePanel: () => void,
    selectedVideo: VideoCardData | null,
    setVideo: (video: VideoCardData) => void,
    clearSelectedVideo: () => void
}


export interface AppStateProviderProps {
    children: JSX.Element | JSX.Element[];
}

const AppStateContext: Context<AppStateContextType> = createContext<AppStateContextType>(null!);

const AppStateProvider = ({ children }: AppStateProviderProps) => {

    const [isSidePanelOpen, setIsSidePanelOpen] = useState<boolean>(false);
    const [selectedVideo, setSelectedVideo] = useState<VideoCardData | null>(null);

    const cycleSidePanel = (): void => {
        setIsSidePanelOpen(!isSidePanelOpen);
    }

    const clearSelectedVideo = (): void => {
        setSelectedVideo(null);
    }

    const setVideo = (video: VideoCardData): void => {
        setSelectedVideo(video);
    }

    const ctx = {
        isSidePanelOpen,
        cycleSidePanel,
        selectedVideo,
        setVideo,
        clearSelectedVideo
    }

    return (
        <AppStateContext.Provider
            value={ctx}
        >
            {children}
        </AppStateContext.Provider>
    )
}

export const useAppState = () => {
    return useContext(AppStateContext);
}

export default AppStateProvider;
